import { get_projects } from '../../../../Services/projectPesquisa';

//Função que traz os dados do banco de dados
export const get = () => {
    return [
        (dispatch, getState) => {
            const order = getState().projectPesquisa.order;
            const th = getState().projectPesquisa.th;
            const qtd_per_page = getState().projectPesquisa.qtd_per_page;
            const pesquisa = getState().projectPesquisa.pesquisa || '';
            const page = getState().projectPesquisa.page;
            const area = getState().projectPesquisa.area.value || '';
            const manager = getState().projectPesquisa.manager.value || '';
            const cod_centro_custo =
                getState().projectPesquisa.cod_centro_custo.value || '';
            const coordinator =
                getState().projectPesquisa.coordinator.value || '';
            const status = getState().projectPesquisa.status.value || '';
            console.log('states', manager);
            get_projects(
                page,
                qtd_per_page,
                order,
                th,
                pesquisa,
                area,
                manager,
                cod_centro_custo,
                coordinator,
                status
            ).then((resp) =>
                dispatch({ type: 'ProjectsPesquisa', payload: resp.data })
            );
        },
    ];
};

//Função que ordena as colunas
export const order = (coluna) => {
    return [
        (dispatch, getState) => {
            const asc = getState().projectPesquisa.asc;

            if (asc === true) {
                dispatch({
                    type: 'GetProjectPesquisa_Desc',
                    desc: true,
                    asc: false,
                    order: 'desc',
                    th: coluna,
                });
            }
            if (asc === false) {
                dispatch({
                    type: 'GetProjectPesquisa_Asc',
                    asc: true,
                    desc: false,
                    order: 'asc',
                    th: coluna,
                });
            }
        },
        get(1),
    ];
};

export const change_qtd_per_page = (event) => {
    return [
        {
            type: 'qtd_per_page_project_pesquisa',
            payload: event.target.value,
        },
        get(1),
    ];
};

export const changePesquisa = (event) => {
    return [
        {
            type: 'pesquisaProjectPesquisa',
            payload: event.target.value,
        },
    ];
};

export const clearPesquisa = (event) => {
    return [
        {
            type: 'clearPesquisaProjectPesquisa',
            payload: '',
        },
        get(1),
    ];
};

export const changePage = (page) => {
    return [
        {
            type: 'changePageProjectPesquisa',
            payload: page,
        },
        get(),
    ];
};

export const search = () => {
    return [
        (dispatch, getState) => {
            const pesquisa = getState().projectPesquisa.pesquisa || '';
            if (pesquisa) {
                return dispatch({
                    type: 'changePageProjectPesquisa',
                    payload: 1,
                });
            }
        },
        get(),
    ];
};
